import apiClient from '../apiClient';
import { POST_IMAGE_ACCOMODATION_ITEM_URL } from '../apiUrl';

const postUploadImageAccomodationItemApi = (Id, data) => {
  return apiClient.post(POST_IMAGE_ACCOMODATION_ITEM_URL(Id), data);
};

export default postUploadImageAccomodationItemApi;
